"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { UserMenu } from "@/components/UserMenu";
import clsx from "clsx";

const items = [
  { href: "/app/all/home", label: "ホーム" },
  { href: "/app/all/chat", label: "チャット" },
  { href: "/app/all/calendar", label: "予定" },
  { href: "/app/all/docs", label: "資料" },
  { href: "/app/all/me", label: "マイページ" },
];

const appVersion = process.env.NEXT_PUBLIC_APP_VERSION ?? "0.1.1";

export function TopBar() {
  const pathname = usePathname();
  return (
    <header className="sticky top-0 z-40 border-b border-[color:var(--line)] bg-white/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1520px] items-center gap-3 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <span className="h-3 w-3 bg-[color:var(--accent)]" />
          <div className="leading-tight">
            <p className="font-display text-[10px] uppercase tracking-[0.28em] text-[color:var(--muted)]">
              Workspace Hub
            </p>
            <h1 className="text-base font-semibold sm:text-lg">Hub ver {appVersion}</h1>
          </div>
        </div>

        <nav className="hidden flex-1 items-center justify-center gap-2 md:flex">
          {items.map((it) => {
            const active = pathname === it.href;
            return (
              <Link
                key={it.href}
                href={it.href}
                className={clsx(
                  "flex min-h-10 items-center justify-center gap-2 border px-3 py-2 text-center text-sm font-medium leading-tight transition",
                  active
                    ? "border-[color:var(--accent-strong)] bg-[color:var(--accent-soft)]"
                    : "border-[color:var(--line)] bg-white hover:bg-[color:var(--bg-subtle)]",
                )}
              >
                {it.label}
              </Link>
            );
          })}
        </nav>

        <div className="ml-auto">
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
